import BigTpl from "../BigTpl";
import {broadcastWebviewshow, VideoBridgeGetFileInfo, VideoBridgeReadyStatusHasReady} from "../../../api";
import {callDeveloperShowFailed, callDeveloperShowSucccess} from "../../../api/noticeDeveloperAPI";
import {_fnIsPortrait, _isPad, _logSuccess} from "../../../common/m_base/util";
import {checkResOK, getCreatedInstanceId} from "../../../api/apiUtil";
import {webviewPreload} from "../../../api/nativeComponent/compWebview";
import {onWebviewLoad} from "../../../api/componentReactListener";

/**
 * mintegral SDK 大模板
 */
export default class BigTplCaseDemo extends BigTpl {

    constructor(...props) {
        super(...props)

        // 表明当前模板如果要成功加载, 至少需要多少个 campaign
        this.expectCampaignNumber = 2
        // 用来存储当前用户选择的, 将要进行播放的子模板
        this.currentChildTpl = null
        // 存储通过当前大模板创建的子模板索引列表
        this.childTplList = []
        // 用来存储当前大模板 slot 插槽的相关配置
        this.slotList = [
            {
                isRequired: true,
                campaign: null,
                webViewId: '',
                playerViewId: '',
                miniEndcardViewId: '',
                endcardViewId: '',
                webViewRect: {top: 20, right: 10, bottom: 120, left: 20, width: 300, height: 300},
                webViewRectNoWidth: {top: 20, right: 10, width: 300, height: 300},
                playerViewRect: {top: 300, right: 100, bottom: 100, left: 200, width: 164, height: 136},
            }, {
                isRequired: true,
                campaign: null,
                webViewId: '',
                playerViewId: '',
                miniEndcardViewId: '',
                endcardViewId: '',
                webViewRect: {top: 500, right: 10, bottom: 20, left: 300, width: 200, height: 100},
                webViewRectNoWidth: {top: 500, right: 10, bottom: 20, left: 300},
                playerViewRect: {top: 600, right: 20, bottom: 10, left: 300, width: 160, height: 90},
            }
        ]

        // 以下为初始化时通过 SDK 获取到的上下文环境变量,
        this.campaignList = null
        this.sdkInfo = null
        this.unitId = null
        this.appSetting = null
        this.unitSetting = null
        this.sdkSetting = null
        this.device = null
        this.bigTemplateInstanceId = null
        this.rootViewInstanceId = null
        this.playVideoMute = null
    }

    async init({JsBridgeRes}) {
        super.init({JsBridgeRes})

        this.enableDebugMode()

        let {campaignList} = await this.initSDKContext()

        // 初始化第一个插槽
        let slot1Index = 0
        let slot1 = this.slotList[slot1Index]
        slot1.campaign = campaignList[slot1Index]
        let {id, data} = await this.createVideoTplNative({slot1});

        // 初始化第二个
        // let campaignWithH5Tpl = campaignList[1]
        // await this.createVideoTplH5({campaign: campaignWithH5Tpl});

        // 初始化完成, 通知 SDK ready
        VideoBridgeReadyStatusHasReady()
    }

    createVideoTplNative({slot1}) {
        return new Promise(async (resolve, reject) => {
            let unitId = this.unitId
            let campaign = slot1.campaign

            // 创建 WebView
            slot1.webViewId = getCreatedInstanceId(await this.createWebview())
            let createdInstanceId = slot1.webViewId;

            // 更新 tplList
            this.addToChildTplList(campaign.id, createdInstanceId);

            // 监听 webviewLoad
            onWebviewLoad({
                expectCmptId: createdInstanceId,
                cb: ({id, data}) => {
                    _logSuccess('videoTplNative 预加载成功', {id, data});
                    document.querySelectorAll('.cta-box .text')[0].textContent = '加载成功'

                    this.setTemplateLoadFinished(id);
                    // resolve({id, data})
                }
            })

            // 预加载这个 webview
            let campaigns = [campaign]
            let templateUrl = campaign && campaign.rv && campaign.rv.template_url
            let filePath = await this.getFilePathByRemoteUrl(templateUrl)
            await webviewPreload({
                unitId,
                id: slot1.webViewId,
                filePath,
                campaigns,
                unitSetting: this.unitSetting,
                rect: slot1.webViewRect
            })

            // setViewAlpha({unitId, id: slot1.playerViewId, alpha: 0.5})
            // setViewScale({unitId, id: slot1.playerViewId, vertical: 0.8, horizon: 0.5})

            resolve(slot1)
        })
    }

    /**
     * 渲染大模板的静态 UI 部分
     */
    renderPageUI({readyCampaignList} = {}) {

        console.log('---------- 注册用户交互事件监听 start ----------')
        // 在大模板中预先初始化用户交互事件所需的 Handler
        this.registerPageHandler()

        // 准备渲染页面所需的数据
        let dataForRender = {
            campaignList: this.formatCampaignList(readyCampaignList),
            isPad: _isPad(),
            isPortrait: _fnIsPortrait(),
        };
        console.log({dataForRender})

        // 渲染页面
        window.MTG_RENDER(dataForRender)
    }

    /**
     * SDK fireEvent webviewshow 时应该调用的逻辑
     */
    async show(res) {
        super.show(res)

        this.initCloseButton()

        // 检查所有 campaign 的 video 资源是否满足播放要求, 并根据检查结果执行不同的交互逻辑
        await this.recheckCampaignVideoReadyState();

    }

    create({campaign}) {

    }

    /**
     * 检查所有 campaign 的 video 资源是否满足播放要求, 并根据检查结果执行不同的交互逻辑
     * @returns {Promise<void>}
     */
    async recheckCampaignVideoReadyState() {
        // webviewshow 时, 更新当前 campaign 列表所有 Video 的下载状态, 将满足播放要求的 video 所在 campaign 的 isReady 设置为 true
        await this.updateCampaignListVideoReadyState();
        // 从 campaign 列表中筛选出 ready 的 campaign
        let readyCampaignList = this.campaignList.filter(campaign => campaign.isReady)

        // >= 2 个 offer 的视频可以播放, 则更新对应 offer 的 ready 状态
        if (readyCampaignList.length >= 1) {
            console.warn('>= 2 个 offer 的视频可以播放')
            this.showAdSuccess({readyCampaignList})
        }

            // 如果 "所有的 offer 的视频都无法播放", 则调用 SDK API 通知开发者 showfailed 回调
        // if (readyCampaignList.length <= 0)
        else {
            console.warn('所有的 offer 都没有满足 loading 条件, 无法播放视频, 调用 SDK API 通知开发者 showfailed 回调')
            this.showAdFailed({readyCampaignList})
        }
    }

    /**
     * 注册大模板页面元素用户交互事件监听
     * @returns {Promise<void>}
     */
    registerPageHandler() {

        // 注册二选一入口的点击事件
        window.mtg_fn_showVideoTemplateLegacy = async ({currentCampaignId = null}) => {
            let curSubTplId = this.childTplList.filter(item => item.campaignId === currentCampaignId)[0].tplInstanceId
            let rect = this.slotList.filter(item => item.webViewId === curSubTplId)[0].webViewRectNoWidth
            let addRes = await this.append({
                parentCmptId: this.rootViewInstanceId,
                childCmptId: curSubTplId,
                rect
            }).catch(err => {
                console.warn({err})
            })
            console.log({addRes})

            if (checkResOK(addRes)) {
                // 通过广播向当前子模板发送 webviewshow
                await broadcastWebviewshow({unitId: this.unitId, data: {subTplId: curSubTplId}})

                // 隐藏大模板
                await this.hideView();
                await this.translucentView();
                await this.scaleView();
            }
        }

    }

    /**
     * 检查是否所有模板都已经 preload 成功
     * @returns {boolean}
     */
    allTplPreloadFinished() {
        let isAllFinished = true
        for (let curTplItem of this.childTplList) {
            if (curTplItem.isPageLoadFinished === false) {
                isAllFinished = false
            }
        }
        return isAllFinished
    }

    /**
     * 初始化页面通用组件
     */
    initComponents() {

    }

    /**
     * 对 campaign 中需要展示的部分信息进行格式化, 以满足模板展示需求
     * @param campaignList
     * @returns {any}
     */
    formatCampaignList(campaignList) {
        let campaignListTemp = JSON.parse(JSON.stringify(campaignList))
        campaignListTemp.forEach(item => {
            let rating = String(item.rating)
            item.rating = rating.indexOf('.') > -1 ? rating : (rating + '.0')
        })
        return campaignListTemp;
    }

    /**
     * webviewshow 时, 更新当前 campaign 列表所有 Video 的下载状态, 将满足播放要求的 video 所在 campaign 的 isReady 设置为 true
     * @returns {Object[]} SDK 返回的所有 video 的下载状态列表
     */
    async updateCampaignListVideoReadyState() {
        // 要获取的 File 类型为 video
        let type = 1
        let resource = this.campaignList.map(item => {
            let ref = item.video_url
            return {type, ref}
        })
        let videoDownloadStateRes = await VideoBridgeGetFileInfo({unitId: this.unitId, resource})

        let videoDownloadStateList = videoDownloadStateRes && videoDownloadStateRes.resource
        this.campaignList && this.campaignList.forEach((item = {}) => {
            let videoUrl = item.video_url
            let videoSize = item.video_size
            let currentVideoDownloadState = videoDownloadStateList && videoDownloadStateList[videoUrl]

            if (currentVideoDownloadState) {
                // 如果 downloaded 标识为 1, 则表示当前视频已经下载完成
                if (currentVideoDownloadState.downloaded === 1) {
                    console.warn('如果 downloaded 标识为 1, 则表示当前视频已经下载完成')
                    item.isReady = true
                }
                // 如果 downloaded 标识无效, 则尝试判断下载的百分比是否满足 rate
                else if (videoSize > 0 && currentVideoDownloadState.videoDataLength / videoSize >= item.ready_rate) {
                    console.warn('如果 downloaded 标识无效, 则尝试判断下载的百分比是否满足 rate')
                    item.isReady = true
                }
            }
        })
    }

    showAdSuccess({readyCampaignList} = {}) {
        console.warn('大模板展示成功, 重新渲染大模板 UI, 发 showsuccess 回调, 上报 onlyImpression')

        console.log('---------- webviewshow 时, 重新渲染大模板静态 UI start ----------')
        // 渲染大模板静态 UI
        this.renderPageUI({readyCampaignList})

        // 大模板被展示时, 调用 SDK API 通知开发者 showsuccess 回调
        callDeveloperShowSucccess({unitId: this.unitId, data: {}})
    }

    async showAdFailed({readyCampaignList, currentCampaignId}) {
        console.error('大模板展示失败, 发 showfailed 回调, 并且关闭当前广告')

        callDeveloperShowFailed({unitId: this.unitId, data: {}})

        let id = currentCampaignId || this.campaignList && this.campaignList[0] && this.campaignList[0].id
        // await this.closeAd({id})
    }
}